import clsx from "clsx";
import { motion } from "framer-motion";
import PropTypes from "prop-types";
import { useState } from "react";
import Skeleton from "react-loading-skeleton";

import { currencyFormat } from "@lib/text.helpers";
import { useBudgetCategories } from "../api";

import "./emergency-budget.scss";

export const EmergencyBudget = ({
  budgetCategoryCode,
  budgetPlan,
  selected,
}) => {
  const imageUrl = `/images/budget/emergency-${selected?.label.toLowerCase()}.png`;
  const { taxInfo: { netIncome = 0 } = {} } = budgetPlan;

  const [loading, setLoading] = useState(true);

  const { data: budgetCategories } = useBudgetCategories();
  const category = budgetCategories?.[budgetCategoryCode];

  return (
    <div className="emergency-budget-view">
      <div className="budget-category-view-content">
        <h3>{category?.label}</h3>
        <motion.div
          className="budget-image"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.img
            aria-hidden
            src={imageUrl}
            onLoad={() => setLoading(false)}
            alt={`${category?.code} budget`}
            animate={{ scale: loading ? 0 : 1 }}
            className={clsx(loading && "loading")}
          />
          {(!selected || loading) && (
            <Skeleton circle containerClassName="tx-skeleton-container" />
          )}
        </motion.div>

        <div className="budget-category-view-option-description">
          {selected ? (
            selected.description
          ) : (
            <>
              <Skeleton width="100%" height="100%" />
              <Skeleton width="100%" height="100%" />
            </>
          )}
        </div>

        <div className="budget-category-view-option-amount">
          {selected ? (
            `-${currencyFormat(selected?.amount * (netIncome / 12))}`
          ) : (
            <Skeleton width="50%" height="100%" />
          )}
        </div>
      </div>
    </div>
  );
};

EmergencyBudget.propTypes = {
  budgetCategoryCode: PropTypes.string.isRequired,
  budgetPlan: PropTypes.shape({
    id: PropTypes.number,
    taxInfo: PropTypes.shape({
      netIncome: PropTypes.number,
    }),
  }),
  selected: PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
    description: PropTypes.string,
    amount: PropTypes.number,
  }),
  onChoiceChange: PropTypes.func,
};
